import { SafeUrl } from '@angular/platform-browser';
import { createReducer, on } from '@ngrx/store';
import * as fromDashboardActions from '../../actions/dashboard/dashboard.actions';

export const profileFeatureKey = 'profile';

export interface State {
  data: string | SafeUrl | null;
}

export const initialState: State = {
  data: null
};

export const reducer = createReducer(
  initialState,
  on(fromDashboardActions.loadProfileImageSuccess, (state, action) => {
    return {
      ...state,
      data: action.profileImg
    };
  })
);
